import { useEffect } from 'react';

import { useCheckoutContext, Article } from '@zooplus/checkout-state';
import { useOmPixels } from '@zooplus/om-pixel-executor';

import { getAppConfig } from '@config/get-app-config';
import {
  PIXEL_EXECUTOR_EVENT_TYPE,
  CUSTOMER_TYPE,
  CHECKOUT_STATE_PROJECT_ID,
} from '@utilities/constants';
import { splitShopId } from '@utilities/utils';

const usePixelExecutor = () => {
  const { checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const { site } = getAppConfig();
  const { executePixels } = useOmPixels(site.id);
  const articles: Article[] | undefined = checkoutState?.cart?.articles;
  const currency: string | undefined = checkoutState?.cart?.currency;
  const customerType: string | undefined = checkoutState?.customer?.customerType;
  const orderId: string | undefined = checkoutState?.cart?.orderId;
  const orderValueGross = `${checkoutState?.cart?.summary?.grandTotal}`;

  useEffect(() => {
    executePixels({
      type: PIXEL_EXECUTOR_EVENT_TYPE,
      currency,
      newCustomer: customerType === CUSTOMER_TYPE.NEW_CUSTOMER,
      orderId,
      orderValueGross,
      cartItemSummaryList: articles?.map((item) => {
        const [shopIdentifier, variantId]: string[] = splitShopId(item?.shopId);
        const grossPrice: number = parseFloat(item?.price as string);
        return {
          articleName: item?.name,
          categoryName: item?.categoryLink,
          grossPrice,
          netPrice: parseFloat((grossPrice - item?.taxValue)?.toFixed(2)),
          quantity: item?.quantity,
          shopIdentifier,
          variantId,
        };
      }),
    });
  }, [articles, currency, customerType, orderId, orderValueGross]);
};

export default usePixelExecutor;
